import { Box } from "@mui/material";
import DashboardLayout from "components/layouts/DashboardLayout";
import UpdatePasswordForm from "components/Settings/UpdatePasswordForm";
import { FormProvider } from "react-hook-form";
import { useUpdatePassword } from "hooks/useUpdatePassword";

function SettingsResetPasswordPage() {
  const { methods, onSubmit, isSubmitting, isSuccess } = useUpdatePassword();

  return (
    <DashboardLayout title="Reset Password">
      <Box className="w-full flex items-center justify-center py-8">
        <Box className="p-16 max-w-xl w-full border bg-white rounded-xl space-y-6 border-color_E8E8E9 border-1">
          <FormProvider {...methods}>
            <form onSubmit={onSubmit} className="space-y-6">
              <UpdatePasswordForm
                isValid={methods.formState.isValid}
                isSubmitting={isSubmitting}
                isSuccess={isSuccess}
              />
            </form>
          </FormProvider>
        </Box>
      </Box>
    </DashboardLayout>
  );
}

export default SettingsResetPasswordPage;
